/**
 * The frame every signed-out page sits in.
 *
 * Four pages a stranger can reach — the front door, the demo sign-in, the
 * sign-in error and the not-found — and until now three of them shared a
 * plain dark card while the fourth used a bare Bootstrap panel. To a prospect
 * they read as four different products. This is one shell, so they read as
 * one company.
 *
 * The layout follows the Vizora marketing email deliberately: a deep indigo
 * masthead carrying the logo, a teal rule, then a light body. Somebody who
 * clicked through from that email should recognise where they have landed
 * without having to think about it.
 *
 * Nothing here talks to the API. These pages have to render with no session,
 * and on a hostname the portal has never heard of.
 */

const CONTACT_EMAIL = 'hello@vizora.com';
const CONTACT_TEL = '+441473355810';
const CONTACT_TEL_DISPLAY = '01473 355810';

export default function PublicShell({
  eyebrow,          // small uppercase label, top right of the masthead
  kicker,           // magenta label above the heading
  heading,
  lead,
  children,         // the light body
  footnote,         // small print directly under the body, above the contact rule
  showContact = true
}) {
  return (
    <div className="public-page">
      <div className="public-card">
        <div className="public-masthead">
          <div className="public-masthead-top">
            {/* The wordmark is baked onto the same indigo as the masthead, so
                it needs no transparency and cannot halo against it. */}
            <img className="public-logo" src="/vizora-logo-light.png" alt="Vizora"
                 width="132" height="39" />
            {eyebrow && <span className="public-eyebrow">{eyebrow}</span>}
          </div>

          {kicker && <p className="public-kicker">{kicker}</p>}
          {heading && <h1 className="public-heading">{heading}</h1>}
          {lead && <p className="public-lead">{lead}</p>}
        </div>

        <div className="public-accent" aria-hidden="true" />

        <div className="public-body">
          {children}

          {footnote && <p className="public-footnote">{footnote}</p>}

          {showContact && (
            <p className="public-contact">
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
              <span aria-hidden="true"> · </span>
              <a href={`tel:${CONTACT_TEL}`}>{CONTACT_TEL_DISPLAY}</a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
